// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/barcodes/barcodes.less
// module id = 3614
// module chunks = 0